// extracted by mini-css-extract-plugin
export default {"successColor":"kt5haY"};